import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field } from 'redux-form'
import { Form, Grid } from 'semantic-ui-react'
import {
  FormCheckbox,
  FormInput,
  FormTextArea,
} from '../../shared/Forms/ReduxForm'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

class Properties extends React.Component {
  render() {
    const dark = config.theme.dark
    // props
    const cssClasses = classNames([
      'Properties',
      'active-window',
      dark && 'inverted',
    ])

    return (
      <div className={cssClasses}>
        <Form>
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form.Group widths="equal">
                  <Field
                    name="name_de"
                    component={FormInput}
                    placeholder={I18n.t('navigation.languages.de')}
                    icon="flag"
                    fluid
                  />
                  <Field
                    name="name_fr"
                    component={FormInput}
                    placeholder={I18n.t('navigation.languages.fr')}
                    icon="flag outline"
                    fluid
                  />
                </Form.Group>
              </Grid.Column>
              <Grid.Column width={12}>
                <Form.Group widths="equal">
                  <Field
                    name="description_de"
                    component={FormTextArea}
                    placeholder={I18n.t('navigation.languages.de')}
                    label={I18n.t(
                      'admin.property_editor.properties.description'
                    )}
                  />
                  <Field
                    name="description_fr"
                    component={FormTextArea}
                    placeholder={I18n.t('navigation.languages.fr')}
                    label={I18n.t(
                      'admin.property_editor.properties.description'
                    )}
                  />
                </Form.Group>
              </Grid.Column>
              <Grid.Column width={12}>
                <Form.Group>
                  <Field
                    name="active"
                    component={FormCheckbox}
                    label={I18n.t('admin.property_editor.properties.active')}
                  />
                  <Field
                    name="sortable"
                    component={FormCheckbox}
                    label={I18n.t('admin.property_editor.properties.sortable')}
                  />
                  <Field
                    name="user_selectable"
                    component={FormCheckbox}
                    label={I18n.t('admin.property_editor.properties.user_selectable')}
                  />
                </Form.Group>
                {/*
                  <Field
                    readOnly disabled
                    name='key' component={FormInput}
                    label={I18n.t('admin.property_editor.properties.key')}
                  />
                  */}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </div>
    )
  }
}

Properties = connect(mapStateToProps, mapDispatchToProps)(Properties)
export default Properties



// WEBPACK FOOTER //
// ./src/components/admin/Properties/Properties.jsx